<template>
    <app-layout>
        <template v-slot:header>
            <Header :title="$t('batch_score_entry_note')"
                    :isColumns="false"
                    :isFilter="false"
            >
            </Header>
        </template>
        <template v-slot:header-mobile>
            <HeaderMobile :title="$t('batch_score_entry_note')"
                          :isColumns="false"
                          :isFilter="false"
            >
            </HeaderMobile>
        </template>
        <b-col v-if="!Object.entries(students).length &&  !isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
            <div class="col-12">
                <div class="row border p-2 d-flex justify-content-center align-items-center">
                    <div class="d-flex flex-column align-items-center">
                        <i class="ri-information-line" style="font-size: 100px">
                        </i>
                        <p>
                            {{$t('no_students_enrolled_in_the_course')}}
                        </p>
                    </div>
                </div>
            </div>
        </b-col>
        <b-col v-else-if="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
        </b-col>
        <div v-else>
            <div class="d-flex  flex-column  mb-3">
                <div class="d-flex justify-content-start overflow-auto">
                    <div>
                        <b-table
                            responsive
                            bordered
                            :items="sectionInformationTableItems"
                            :fields="fields"
                            class="border "
                        ></b-table>
                    </div>
                </div>
            </div>
            <div class=" d-flex justify-content-start overflow-auto" v-if="gradesItems.length > 0 && sectionGrades.instructor_can_edit_grade_scores">
                <div>
                    <b-table-simple responsive bordered class="border">
                        <b-tbody>
                            <b-tr v-for="(field, fieldIndex) in gradesFields" :key="fieldIndex">
                                <b-th class="header" v-if="field.key==='action' ">
                                    <span v-if="!isFinalizeExam">{{field.label}}</span>
                                </b-th>
                                <b-th class="header" v-else>{{ field.label }}</b-th>
                                <b-td
                                    v-for="(item, itemIndex) in gradesItems"
                                    :key="itemIndex"
                                    class="text-center"
                                >
                                    <div v-if="field.key === 'score'">
                                        <div v-if="item.edit">
                                            <ValidationProvider
                                                name="score"
                                                rules="required"
                                                v-slot="{ valid, errors }"
                                            >
                                                <b-input
                                                    v-model="item.score"
                                                    type="number"
                                                    max="100"
                                                    min="0"
                                                    @change="handleChangeInput(item, itemIndex)"
                                                    class="text-center"
                                                    style="max-width: 65px"
                                                ></b-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </ValidationProvider>
                                        </div>
                                        <div v-else class="text-center">{{ item.score }}</div>
                                    </div>
                                    <div v-else-if="field.key === 'action'">
                                        <div class="d-flex align-items-center justify-content-center">

                                            <div v-if="!item.edit && !['100','0'].includes(item.score) && !isFinalizeExam">
                                                <a
                                                    role="button"
                                                    class="editButton"
                                                    @click="onHandleEdit(item)"
                                                    v-b-tooltip.hover
                                                    :title="$t('edit')"
                                                >
                                                    <i class="ri-edit-box-line" style="font-size: 20px"></i>
                                                </a>
                                            </div>
                                            <div v-if="item.edit && item.isSave">
                                                <a
                                                    role="button"
                                                    class="deleteButton mr-2"
                                                    @click="onHandleSave({ item, index: itemIndex })"
                                                    v-b-tooltip.hover
                                                    :title="$t('save')"
                                                >
                                                    <i
                                                        class="ri-check-double-line"
                                                        style="font-size: 20px; color: blue"
                                                    ></i>
                                                </a>
                                            </div>
                                            <div v-if="item.edit">
                                                <a
                                                    role="button"
                                                    class="deleteButton"
                                                    @click="onHandleDelete(item, itemIndex)"
                                                    v-b-tooltip.hover
                                                    :title="$t('clear')"
                                                >
                                                    <i
                                                        class="ri-delete-bin-6-line"
                                                        style="font-size: 20px; color: red"
                                                    ></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        {{ item[field.key] }}
                                    </div>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </div>

            <datatable-filter v-show="true" @filter="searchStudent" @filterClear="filterClear">
                <ValidationObserver ref="formModalValidate">
                    <b-row>
                        <b-col sm="6" md="4" lg="3" xl="2" >
                            <b-form-group :label="$t('name')">
                                <b-form-input size="sm" v-model="filter.name"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col sm="6" md="4" lg="3" xl="2">
                            <b-form-group :label="$t('surname')">
                                <b-form-input size="sm" v-model="filter.surname" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" md="4" lg="3" xl="2">
                            <b-form-group :label="$t('student_number')">
                                <b-form-input size="sm" v-model="filter.student_number" ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </datatable-filter>
            <ValidationObserver ref="studentExamForm">
                <div class="card shadow-sm border rounded overflow-hidden mb-3">
                    <vue-good-table
                        :columns="goodTableColumns"
                        :rows="goodTableRows"
                        :row-style-class="rowStyleFn"
                        styleClass="vgt-table bordered striped hover custom-good-table m-0"
                        :sort-options="{ enabled: false }"
                    >
                        <template slot="table-column" slot-scope="props">
                            <div v-if="props.column.isExam" class="d-flex flex-column align-items-center text-center p-1 w-100">
                                <div class="exam-header-title w-100 mb-2 py-1 px-2 rounded">
                                    <span class="font-weight-bold text-primary text-uppercase exam-title-text">
                                        {{ props.column.exam.name }} - {{props.column.examKey +1}}
                                    </span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center mb-1">
                                    <b-form-checkbox
                                        ref="examStatusCheckbox"
                                        :disabled="props.column.examItem.has_finalize || (hasMakeUpExam && !props.column.examItem?.is_make_up)"
                                        @change="examStatusCheck(props.column.exam, props.column.examItem, props.column.examKey)"
                                        :id="'header-checkbox-' + props.column.exam.id + '-' + props.column.examKey"
                                        v-model="props.column.exam.exams[props.column.examKey].is_active"
                                    >
                                        <span class="small-text text-muted">{{ props.column.examItem.date ? toLocaleDate(props.column.examItem.date) : null }}</span>
                                    </b-form-checkbox>
                                </div>
                                <div class="d-flex flex-column align-items-center justify-content-center text-center w-100">
                                    <span class="small-text text-muted text-nowrap">{{ $t('attended_the_exam') }}</span>
                                    <span class="small-text font-weight-bold text-dark text-break w-100 px-1" style="line-height: 1.2;">{{ props.column.examItem.name }}</span>
                                </div>
                            </div>

                            <div v-else-if="props.column.field === 'instructors_letter_grade'" class="d-flex flex-column align-items-center text-center w-100">
                                <span class="font-weight-bold text-dark text-nowrap" style="font-size: 0.85rem;">{{ $t('instructor') }}</span>
                                <span class="font-weight-bold text-dark text-nowrap" style="font-size: 0.85rem;">{{ $t('letter_grade') }}</span>
                            </div>

                            <div v-else-if="props.column.field === 'full_name'" class="text-center w-100 text-nowrap">
                                <span class="font-weight-bold text-dark" style="font-size: 0.85rem;">{{ $t('name') }} {{ $t('surname') }}</span>
                            </div>

                            <div v-else-if="props.column.field === 'student_number'" class="text-center w-100 text-nowrap">
                                <span class="font-weight-bold text-dark" style="font-size: 0.85rem;">{{ $t('student_number') }}</span>
                            </div>

                            <div v-else-if="props.column.field === 'score'" class="text-center w-100 text-nowrap">
                                <span class="font-weight-bold text-dark" style="font-size: 0.85rem;">{{ $t('grade') }}</span>
                            </div>

                            <div v-else class="text-center w-100 text-nowrap">
                                <span class="font-weight-bold text-dark" style="font-size: 0.85rem;">{{ props.column.label }}</span>
                            </div>
                        </template>

                        <template slot="table-row" slot-scope="props">
                            <template v-if="props.row.isFooterRow">
                                <div v-if="props.column.isExam" class="d-flex flex-column align-items-center justify-content-center p-1 w-100">
                                    <b-button
                                        v-show="shouldShowCancelButton(props.column.exam, props.column.examItem)"
                                        variant="success"
                                        size="sm"
                                        class="mb-1 w-100 btn-responsive-text"
                                        @click="unpublishExams(props.column.exam, props.column.examItem.id)"
                                    >
                                        {{$t('finalize_grade_cancel')}}
                                    </b-button>
                                    <b-button
                                        v-show="props.column.examItem.is_active && !props.column.examItem.has_finalize"
                                        variant="success"
                                        size="sm"
                                        class="mb-1 w-100"
                                        @click="saveExams(props.column.exam, props.column.examItem, props.column.examKey)"
                                    >
                                        {{$t('save')}}
                                    </b-button>
                                    <b-button
                                        v-show="props.column.examItem.id && !props.column.examItem.has_finalize && props.column.examItem.is_finalize"
                                        variant="danger"
                                        size="sm"
                                        class="w-100"
                                        @click="saveFinalize(props.column.examItem)"
                                    >
                                        {{ $t('finalize') }}
                                    </b-button>
                                </div>
                                <span v-else></span>
                            </template>

                            <template v-else>
                                <span v-if="props.column.field === 'edit_action'">
                                    <b-button variant="outline-primary" size="sm" class="table-action-btn" v-if="checkPermission('examscore_updateforstudentprogram')"  @click="handleOpenEditModal(props.row, props.index)">
                                        <i class="ri-edit-box-line"></i>
                                    </b-button>
                                </span>

                                <span v-else-if="props.column.field === 'student_number'">
                                    {{ props.row?.student_number }}
                                </span>

                                <span v-else-if="props.column.field === 'full_name'">
                                    {{ props.row?.name }} {{ props.row?.surname }}
                                </span>

                                <span v-else-if="props.column.isExam">
                                    <div class="d-flex align-items-center justify-content-between" v-if="(!props.column.examItem.is_make_up || (props.column.examItem.is_make_up && selectedExams[props.column.exam.id][props.column.examKey + 1]?.[pagination.currentPage][props.index]?.make_up_exam_definition_ids))">
                                        <ValidationProvider
                                            :name="`attended-${props.column.exam.id}-${props.column.examItem.rank}-${props.index}`"
                                            rules="required"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-checkbox
                                                :disabled="!props.column.examItem.is_active || props.column.examItem.has_finalize || (props.column.examItem.is_make_up && !selectedExams[props.column.exam.id][props.column.examKey + 1]?.[pagination.currentPage][props.index]?.isStudentHasMakeUpExam)"
                                                 v-if="selectedExams[props.column.exam.id] && selectedExams[props.column.exam.id][props.column.examKey + 1]?.[pagination.currentPage][props.index]"
                                                :id="'student-checkbox-' + props.column.exam.id + '-' + props.column.examKey + '-' + props.index"
                                                :value="1"
                                                :unchecked-value="0"
                                                @change="examStatusChange(selectedExams[props.column.exam.id][props.column.examKey + 1][pagination.currentPage][props.index])"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                v-model="selectedExams[props.column.exam.id][props.column.examKey + 1][pagination.currentPage][props.index].attended"
                                            >
                                            </b-form-checkbox>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </ValidationProvider>
                                        <div class="width-100 ml-1">
                                            <ValidationProvider
                                                :name="`score-${props.column.exam.id}-${props.column.examItem.rank}-${props.index}`"
                                                :rules="(!props.column.examItem.is_active || props.column.examItem.has_finalize || !selectedExams[props.column.exam.id][props.column.examKey + 1][props.index]?.attended) ? '' : 'required'"
                                                v-slot="{ valid, errors }"
                                            >
                                                <b-form-input
                                                    v-if="selectedExams[props.column.exam.id] && selectedExams[props.column.exam.id][props.column.examKey + 1]?.[pagination.currentPage][props.index]"
                                                    :placeholder="$t('grade_entry')"
                                                    type="number"
                                                    min="0"
                                                    max="100"
                                                    @input="restrictScore($event, props.column.exam.id, props.column.examKey + 1, props.index)"
                                                    v-model="selectedExams[props.column.exam.id][props.column.examKey + 1][pagination.currentPage][props.index].score"
                                                    :disabled="props.column.examItem.has_finalize  || !props.column.examItem.is_active  || !selectedExams[props.column.exam.id][props.column.examKey + 1][pagination.currentPage][props.index].attended || (hasMakeUpExam &&  !selectedExams[props.column.exam.id][props.column.examKey + 1]?.[pagination.currentPage][props.index]?.isStudentHasMakeUpExam)"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </span>

                                <span v-else-if="props.column.field === 'score'">
                                    {{ props.row?.score ? props.row.score : '-' }}
                                </span>

                                <span v-else-if="props.column.field === 'instructors_letter_grade'">
                                    {{ props.row?.instructors_letter_grade ? props.row.instructors_letter_grade : '-' }}
                                </span>
                            </template>
                        </template>

                        <div slot="emptystate" class="text-center p-3 text-muted">
                            {{ $t('no_result_2') }}
                        </div>
                    </vue-good-table>
                </div>

                <b-col class="w-100 d-flex flex-column flex-md-col justify-content-center align-items-center gap-3">
                    <div class="w-80 mb-3 w-md-auto" v-if="!hiddenPaginateSelect">
                        <b-form-select
                            v-model="selected"
                            @change="onPerPageChange(selected)"
                            :options="options"
                            class="form-select form-select-sm"
                        ></b-form-select>
                    </div>

                    <div class="w-100 d-md-flex justify-content-md-center align-items-center w-md-auto overflow-x-auto">
                        <ul class="pagination mb-0">
                            <li class="page-item">
                                <span class="page-link" @click="decrementPage">{{ $t('previous') }}</span>
                            </li>
                            <li
                                :class="pagination.currentPage === i ? 'page-item active' : 'page-item'"
                                v-for="i in pagination.totalPage"
                                :key="i"
                                @click="onSelectPage(i)"
                            >
                                <span class="page-link">{{ i }}</span>
                            </li>

                            <li class="page-item">
                                <span class="page-link" @click="incrementPage">{{ $t('next') }}</span>
                            </li>
                        </ul>
                    </div>
                </b-col>
            </ValidationObserver>
        </div>
        <CommonModal ref="editGradeModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
            <template v-slot:CommonModalTitle>
                {{ $t('edit').toUpper() }}
            </template>"
            <template v-slot:CommonModalContent>
                <EditGrade :student="selectedStudent" :exams="examTypeArray"  :examScore="examScore" v-if="formProcess==='edit_grade'" @successScoreUpdate="successScoreUpdate"/>
            </template>
        </CommonModal>
        <log-control :keyParameter="keyParameter" @stopPolling="updateTable" />
    </app-layout>
</template>
<script>

import qs from "qs";
import ExamDefinationService from "@/services/ExamDefinationService"
import LogControl from "@/components/elements/logControl.vue";
import EditGrade from "@/modules/UNIVERSITY/BATUM/BulkGradeEntry/pages/EditGrade.vue";
import {mapGetters} from "vuex";

export default {
    components: {
        EditGrade,
        LogControl
    },
    data() {
        return {
            keyParameter: null,
            fields: [
                {
                    key: 'staff',
                    label:this.$t('teaching_staff'),
                },
                {
                    key: 'course_name',
                    label: this.$t('course_name'),
                },
                {
                    key: 'section',
                    label: this.$t('section'),
                },
                {
                    key: 'student_count',
                    label: this.$t('total_student_count'),
                },
                {
                    key: 'evaluation_name',
                    label: this.$t('evaluation'),
                },


            ],
            sectionInformationTableItems: [],
            gradesItems:[],
            gradesFields:[
                {
                    key: 'grade',
                    label:this.$t('grade'),
                },
                {
                    key: 'score',
                    label: this.$t('score'),
                },
                {
                    key: 'action',
                    label: this.$t('action'),
                },
            ],
            selected:10,
            options: [
                { value: 5, text: 5 },
                { value: 10, text: 10 },
                { value: 15, text: 15 },
                { value: 20, text: 20 },

            ],
            royalStudents:[],
            royalSelectedExams:[],
            royalTotalPage: 0,
            royalGrades: [],
            hiddenPaginateSelect: false,
            isExamOptions:false,
            selectedExams: {},
            allExams: [],
            examTypeArray: [],
            hasMakeUpExam: false,
            examScore: [],
            students: [],
            paginateData:{},
            pagination:{
                currentPage:1,
                perPage:10,
                totalPage:0,
            },
            replacementStudent:[],
            isLoading:false,
            sectionGrades:null,
            filter:{
                name:null,
                surname:null,
                student_number:null
            },
            exams:[],
            formProcess :null,
            selectedStudent:[],

        };
    },
    metaInfo() {
        return {
            title: this.$t('batch_score_entry_note'),
        }
    },
    created() {
        this.getSectionInformation();
        this.getGradesInformation()
    },
    computed:{
        isFinalizeExam() {
            let examCount=0
            let examFinalizeCount=0
            if (this.allExams.length) {
                this.allExams.forEach((exam) => {
                    exam.exams.forEach(val => {
                        examCount++
                        if (val.is_finalized){
                            examFinalizeCount++
                        }
                    })
                })
            }
            return examCount ===examFinalizeCount
        },
        goodTableColumns() {
            const cols = [
                {
                    label: '',
                    field: 'edit_action',
                    sortable: false,
                    width: '60px',
                    thClass: 'text-center align-middle border bg-white',
                    tdClass: 'text-center align-middle border',
                },
                {
                    label: this.$t('student_number'),
                    field: 'student_number',
                    sortable: false,
                    width: '140px',
                    thClass: 'text-center align-middle border bg-white',
                    tdClass: 'text-center align-middle border font-weight-bold',
                },
                {
                    label: `${this.$t('name')} ${this.$t('surname')}`,
                    field: 'full_name',
                    sortable: false,
                    width: '200px',
                    thClass: 'text-center align-middle border bg-white',
                    tdClass: 'text-center align-middle border',
                },
            ];

            if (this.examTypeArray && this.examTypeArray.length) {
                this.examTypeArray.forEach((exam) => {
                    if (exam.exams && exam.exams.length) {
                        exam.exams.forEach((i, key) => {
                            cols.push({
                                label: exam.name,
                                field: `exam_${exam.id}_${key}`,
                                sortable: false,
                                isExam: true,
                                exam: exam,
                                examItem: i,
                                examKey: key,
                                width: '200px',
                                thClass: 'text-center align-middle border bg-white p-2',
                                tdClass: 'text-center align-middle border p-2',
                            });
                        });
                    }
                });
            }

            cols.push({
                label: this.$t('grade'),
                field: 'score',
                sortable: false,
                width: '110px',
                thClass: 'text-center align-middle border bg-white',
                tdClass: 'text-center align-middle border font-weight-bold',
            });

            cols.push({
                label: `${this.$t('instructor')} ${this.$t('letter_grade')}`,
                field: 'instructors_letter_grade',
                sortable: false,
                width: '160px',
                thClass: 'text-center align-middle border bg-white',
                tdClass: 'text-center align-middle border font-weight-bold',
            });

            return cols;
        },
        goodTableRows() {
            const currentStudents = this.students[this.pagination.currentPage] || [];
            if (!currentStudents.length) return [];
            return [
                ...currentStudents,
                { isFooterRow: true, student_program_id: 'footer-action-row' }
            ];
        },
    },
    methods: {
        rowStyleFn(row) {
            if (row && row.isFooterRow) {
                return 'table-footer-row bg-white font-weight-bold';
            }
            return '';
        },
        formClear(){
            this.formProcess=null
            this.selectedStudent=null
        },
        shouldShowCancelButton(exam, currentExam) {
            if (!currentExam.has_finalize) return false;

            const hasAnyGlobalMakeUp = this.examTypeArray.some(type =>
                type.exams.some(e => e.is_make_up)
            );

            if (hasAnyGlobalMakeUp) {

                return currentExam.is_make_up;
            }

            return true;
        },
        paginateItems(items, perPage) {
            const paginated = {};
            for (let i = 0; i < items.length; i += perPage) {
                const page = Math.floor(i / perPage) + 1;
                paginated[page] = items.slice(i, i + perPage);
            }
            return paginated;
        },
        mapExamScores(examScoreData, students, examTypeArray, perPage) {
            let selectedExams = {};
            examTypeArray.forEach((value) => {
                selectedExams[value.id] = {};
                for (let i = 1; i <= value.number_of_exams; i++) {
                    let studentData = Object.values(students).flat().map((student) => {
                        const isStudentHasMakeUp = student.make_up_exam_definition_ids?.includes(Number(value.id))
                        return {
                            exam_type:value.exam_type,
                            student_program_id: student.student_program_id,
                            attended: 1,
                            score: null,
                            instructors_letter_grade: student.instructors_letter_grade,
                            isStudentHasMakeUpExam:isStudentHasMakeUp,
                            make_up_exam_definition_ids: student?.make_up_exam_definition_ids,
                            calculate_score: student.score,
                        }
                    });
                    selectedExams[value.id][i] = studentData;
                }
            });
            Object.entries(examScoreData).forEach(([exam_definition_id, exam_rank]) => {
                if (selectedExams[exam_definition_id]) {
                    Object.entries(exam_rank).forEach(([rank, scoreItems]) => {
                        if (selectedExams[exam_definition_id][rank]) {
                            scoreItems.forEach((item) => {
                                const index = selectedExams[exam_definition_id][rank].findIndex(
                                    (entry) => entry.student_program_id === item.student_program_id
                                );
                                if (index !== -1) {
                                    const currentStudentData = selectedExams[exam_definition_id][rank][index];
                                    this.$set(selectedExams[exam_definition_id][rank], index, {
                                        student_program_id: item.student_program_id,
                                        attended: item.attended ? 1 : 0,
                                        score: item.score,
                                        make_up_exam_definition_ids: currentStudentData.make_up_exam_definition_ids,
                                        instructors_letter_grade: item.instructors_letter_grade,
                                        calculate_score: item.calculate_score,
                                    });
                                }
                            });
                        }
                    });
                }
            });
            Object.entries(selectedExams).forEach(([exam_definition_id, exam_rank]) => {
                Object.entries(exam_rank).forEach(([rank, data]) => {
                    selectedExams[exam_definition_id][rank] = this.paginateItems(data, perPage);
                });
            });
            return selectedExams;
        },
        async getExamOptions() {
            this.hasMakeUpExam = false;
            const examOptions = {};
            this.allExams.forEach((item) => {
                let number_of_exams=item.number_of_exams
                if (!examOptions[item.id]) {
                    if(item.exams.length > item.number_of_exams){
                      item.number_of_exams = item.exams.length
                    }
                    examOptions[item.id] = {
                        id: item.id,
                        name: item.exam_type_text,
                        exam_type:item.exam_type,
                        section_id: item.section_id,
                        effect_ratio: item.effect_ratio,
                        number_of_exams: item.number_of_exams,
                        exams: [],
                    };
                }
                for (let i = 0; i < item.number_of_exams; i++) {
                    const examData = item.exams && item.exams[i];
                    let name = `${item.exam_type_text}-${i+1}`
                    if(number_of_exams===1){
                      name = `${item.exam_type_text}`
                    }

                    if(examData?.is_make_up){
                      this.hasMakeUpExam = true
                      name = `${item.exam_type_text} - (MAKE-UP)`
                    }
                    examOptions[item.id].exams.push({
                      name: name,
                      id: examData ? examData.id : null,
                      rank: examData ? examData.rank - 1 : i,
                      is_active: false,
                      has_finalize: examData ? examData.is_finalized : false,
                      is_finalize: false,
                      date: examData ? examData.date : null,
                      is_make_up: examData ? examData?.is_make_up : false,
                    });
                }
                examOptions[item.id].exams.sort((a, b) => a.rank - b.rank);
            });
            this.examTypeArray = Object.values(examOptions);
        },
        async getGradesInformation(){
            try {
                const res = await  ExamDefinationService.sectionGrades(this.$route.params.sectionId)
                this.sectionGrades = res.data.data;
                this.royalGrades=res.data.data.grades
                if (!this.sectionInformationTableItems.length) {
                    this.sectionInformationTableItems.push({
                        staff: this.sectionGrades.instructor_name,
                        course_name: `${this.sectionGrades.course_name} (${this.sectionGrades.course_code})`,
                        section: this.sectionGrades.section,
                        student_count: this.sectionGrades.student_count,
                        evaluation_name:this.sectionGrades.evaluation_name
                    });
                }
                if(res.data.data.grades.length > 0) {
                    this.gradesItems=res.data.data.grades.map((entry) => {
                        return {
                            ...entry,
                            action:null,
                            edit:false,
                            isSave:false,
                        }
                    });
                }
            }catch (error) {
                this.showErrors(error);
            }
        },
        async getSectionInformation() {
            this.isLoading = true;
            const config = {
                params: {
                    filter: { section_id: this.$route.params.sectionId },
                    limit: -1,
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            try {
                const [exams, studentList, examScore] = await Promise.all([
                    ExamDefinationService.getAll(config),
                    ExamDefinationService.getStudents(this.$route.params.sectionId),
                    ExamDefinationService.getExamScore(config),
                ]);
                this.allExams = exams.data.data;
                this.students = studentList.data.data;
                this.replacementStudent = this.students;
                this.examScore = examScore.data.data;
                if (!this.isExamOptions) {
                    await this.getExamOptions();
                }
                this.paginationPage();
                await this.initializeAttendance(this.examScore.length > 0);
            } finally {
                this.isLoading = false;
                this.hiddenPaginateSelect=false
            }
        },
        async initializeAttendance(isExamScore) {
            if (!this.allExams || !Object.keys(this.students).length) return;

            const examScoreData = isExamScore ? await this.getExamScore() : {};
            this.selectedExams = this.mapExamScores(examScoreData, this.students, this.examTypeArray, this.pagination.perPage);
            this.royalSelectedExams = this.selectedExams;
        },
        async getExamScore() {
            const result = {};
            this.examScore.forEach((value) => {
                if (!result[value.exam_definition_id]) {
                    result[value.exam_definition_id] = {};
                }
                if (!result[value.exam_definition_id][value.exam_rank]) {
                    result[value.exam_definition_id][value.exam_rank] = [];
                }
                result[value.exam_definition_id][value.exam_rank].push({
                    student_program_id: value.student_program_id,
                    attended: value.attended,
                    score: value.score,
                });
            });
            return result;
        },
        paginationPage() {
            this.paginateData = this.paginateItems(this.replacementStudent, this.pagination.perPage);
            this.students = this.paginateData;
            this.royalStudents = this.students;
            this.pagination.totalPage = Object.keys(this.paginateData).length;
            this.royalTotalPage = this.pagination.totalPage;
        },
        examStatusCheck(exam, i, key) {
            let count = 0;
            let start = 0;
            const isMakeUpExam=exam.exams[key].is_make_up
            const examDefinitionId =exam.id

            if (isMakeUpExam){
                Object.entries(this.selectedExams[exam.id][key+1]).forEach(([page, students]) => {
                    const newStudents = []
                    newStudents.push(...students.map((student)=>{
                        const isStudentHasMakeUp = student.make_up_exam_definition_ids?.includes(examDefinitionId)
                        return {
                            ...student,
                            isStudentHasMakeUpExam:isStudentHasMakeUp,
                            attended: isStudentHasMakeUp?1:0
                        }
                    }))
                    this.selectedExams[exam.id][key+1][page]=newStudents
                })
            }

            this.selectedExams[exam.id][key+1][this.pagination.currentPage].forEach((item) => {
                if ((!item.attended && !item.score) || item.score) {
                    exam.exams[key].is_finalize = true
                } else if (isMakeUpExam){
                    exam.exams[key].is_finalize = true
                }
                else {
                    exam.exams[key].is_finalize = false
                }
            })


            //Not Girilirken Sınav sırası kontrol edilir. talep üzerine kaldırılmıstır
            // if (exam.exams.length > 1) {
            //     for (let i = 0; i < key; i++) {
            //         if (!exam.exams[key - 1]) {
            //             break
            //         }
            //
            //         this.selectedExams[exam.id][i + 1][this.pagination.currentPage].forEach((item) => {
            //             if ((!item.score && item.attended) ||  !exam.exams[key - 1].id) {
            //                 start += 1
            //                 exam.exams[key].is_active = false
            //             }
            //         })
            //     }
            //
            // }
            // if (start > 0) {
            //     this.$toast.error(this.$t('previous_exams_must_be_taken'))
            //     start = 0
            //     return
            // }
            this.examTypeArray.forEach(value => {
                value.exams.forEach(ex => {
                    if (ex.is_active) {
                        count++;
                    }
                });
            });
            if (count > 0) {
                this.examTypeArray.forEach(value => {
                    value.exams.forEach(ex => {
                        ex.is_active = false;
                    });

                });
                this.examTypeArray.forEach(value => {
                    if (value.id === exam.id) {
                        value.exams.forEach(ex => {
                            if (ex.rank === i.rank) {
                                ex.is_active = !ex.is_active;
                            }
                        });
                    }
                });
            } else {
                this.examTypeArray.forEach(value => {
                    if (value.id === exam.id) {
                        value.exams.forEach(ex => {
                            if (ex.rank === i.rank) {
                                ex.is_active = false
                            }
                        });
                    }
                });
            }
        },
        async calculateExamScore() {
            try {
                await ExamDefinationService.calculateExams(this.$route.params.sectionId);
            }  catch (error) {
                this.showErrors(error);
            }
        },
        async saveExams(exam, i,key) {
            if (!(await this.$refs.studentExamForm.validate())) return;
            const examRank = this.selectedExams[exam.id][i.rank + 1] || this.selectedExams[exam.id][i.rank];
            const studentGrades = Object.values(examRank).flat().filter((item) =>
                (item.attended && item.score || !item.attended && !item.score) && item.student_program_id
            );
            const formData = {
                exam_definition_id: exam.id,
                rank: i.rank + 1,
                scores: studentGrades,
            };
            try {
                const res = await ExamDefinationService.examScoreSave(formData);
                this.$toast.success(this.$t(`api.${res.data.message}`));
                this.isExamOptions = true;
                await this.getSectionInformation();
                this.examStatusCheck(exam,i,key)
            } catch (error) {
                this.$toast.error(error.data.message);
            } finally {
                const targetExam = exam.exams[i.rank] || exam.exams[i.rank - 1];
                if (targetExam) targetExam.is_active = true;
            }
        },
        async unpublishExams(exam,exam_id) {
            if (!(await this.$refs.studentExamForm.validate())) return;

            try {
                const res = await ExamDefinationService.unpublishExam(exam_id);
                this.$toast.success(this.$t(`api.${res.data.message}`));
                this.isExamOptions = false;
                this.keyParameter = 'exams/unpublish/'+exam_id
                //await this.calculateExamScore();
                this.isLoading = true;

            } catch (error) {
                this.$toast.error(error.data.message);
            }
        },
        examStatusChange(examStatus) {
            if (!examStatus.attended) {
                examStatus.score = null
            }
        },
        async saveFinalize(i) {
            if (!i.id) return
            try {
                const res = await ExamDefinationService.saveExamPublish(i.id);
                this.$toast.success(this.$t("api." + res.data.message));
                this.isExamOptions=false
                this.keyParameter = 'exams/publish/'+i.id

                //await this.calculateExamScore();
                this.isLoading = true;
            } catch (error) {
                this.$toast.error(error.data.message);
            }
        },
        turkishStringToUpperCase(string) {
            const letters = { i: 'İ', ş: 'Ş', ğ: 'Ğ', ü: 'Ü', ö: 'Ö', ç: 'Ç', ı: 'I' };
            return string.replace(/(([iışğüçö]))/g, (letter) => letters[letter]).toUpperCase();
        },
        async searchStudent() {
            const examScoreData = await this.getExamScore();
            const filterKeys = Object.keys(this.filter).filter((key) => this.filter[key]);

            if (!filterKeys.length) {
                this.resetToOriginalData();
                return;
            }
            const filteredArray = this.replacementStudent.filter((student) =>
                filterKeys.every((key) => {
                    const filterValue = this.turkishStringToUpperCase(this.filter[key]).trim();
                    const studentNumber = this.turkishStringToUpperCase(student.student_number || '').trim();
                    const studentName = this.turkishStringToUpperCase(student.name || '').trim();
                    const studentSurname = this.turkishStringToUpperCase(student.surname || '').trim();
                    return studentNumber.includes(filterValue) || studentName.includes(filterValue) || studentSurname.includes(filterValue);
                })
            );
            if (!filteredArray.length) {
                this.resetToOriginalData();
                return;
            }
            const paginateData = this.paginateItems(filteredArray, this.pagination.perPage);
            this.students = paginateData;
            this.pagination.currentPage = 1
            this.pagination.totalPage = Object.keys(paginateData).length;
            this.selectedExams = this.mapExamScores(examScoreData, paginateData, this.examTypeArray, this.pagination.perPage);
            this.hiddenPaginateSelect = true;
        },
        resetToOriginalData() {
            this.students = this.royalStudents;
            this.selectedExams = this.royalSelectedExams;
            this.pagination.totalPage = this.royalTotalPage;
            this.hiddenPaginateSelect = false;
        },
        filterClear() {
            this.filter = {};
            this.resetToOriginalData();
        },
        restrictScore(event, examId, rank, index) {
            let value = event;
            if (isNaN(value) || value < 0) value = 0;
            else if (value > 100) value = 100;

            this.$set(this.selectedExams[examId][rank][this.pagination.currentPage], index, {
                ...this.selectedExams[examId][rank][this.pagination.currentPage][index],
                score: value,
            });
        },
        decrementPage() {
            if (this.pagination.currentPage > 1) this.pagination.currentPage -= 1;
        },
        incrementPage() {
            if (this.pagination.totalPage > this.pagination.currentPage) this.pagination.currentPage += 1;
        },
        onSelectPage(page) {
            this.pagination.currentPage = page;
        },
        onPerPageChange(page) {
            this.pagination.perPage = page;
            this.pagination.currentPage = 1;
            this.getSectionInformation();
        },
        onHandleEdit(item){
            item.edit=true
        },
        onHandleDelete(item,index){
            if (item.score!==this.royalGrades[index].score){
                item.isSave=false
            }
            item.score=this.royalGrades[index].score
            item.edit=false;

        },
        handleChangeInput(item,index){
            if (item.score!==this.royalGrades[index].score){
                item.isSave=true
            }
        },
        async onHandleSave(row,index) {
            try {
                const config ={
                    grades:{
                        ...this.gradesItems,
                    }
                }
                const res = await ExamDefinationService.updateSectionGrade(this.$route.params.sectionId,config);
                this.$toast.success(this.$t('api.' + res.data.message));
                await this.getGradesInformation()

            }catch (error) {
                this.showErrors(error)
            }
        },
        updateTable(){
            this.getSectionInformation();
            this.getGradesInformation();
        },
        handleOpenEditModal(student) {
            this.selectedStudent=student
            this.formProcess='edit_grade'
            this.$refs.editGradeModal.$refs.commonModal.show()
        },
        successScoreUpdate(){
            this.formClear()
            this.$refs.editGradeModal.$refs.commonModal.hide()
            this.updateTable()
        }
    },
    watch:{
        // 'hiddenPaginateSelect':function (newValue){
        //     if (newValue){
        //         const allowedFields =['edit_action','field','score','instructors_letter_grade','student_number','full_name']
        //         this.goodTableColumns.forEach(column => {
        //             if (!allowedFields.includes(column.field)) {
        //                this.examStatusCheck(column.exam,column.examItem,column.examKey)
        //             }
        //         });
        //     }
        // }
    }

};
</script>
<style scoped>
.small-text {
    font-size: 0.7rem;
    line-height: 1;
}

.text-nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mobile-th {
    padding: 0.2rem !important;
    min-width: 20px !important;
    max-width: 20px !important;
}

.responsive-text {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 !important;
    margin: 0 !important;
    gap: 2px;
}

.btn-responsive-text{
    font-size: 7px;
    font-weight: bold;
    line-height: 1.5;
}

@media (min-width: 1300px) {
    .btn-responsive-text {
        font-size: 10px;
        font-weight: bold;
    }

}


@media (max-width: 768px) {
    .responsive-text {
        flex-direction: column;
        align-items: flex-start;
        gap: 1px;
    }

    .mobile-th {
        min-width: 50px !important;
        max-width: 70px !important;
    }

    .small-text {
        font-size: 0.6rem;
    }
}

@media (max-width: 480px) {
    .responsive-text {
        gap: 0;
    }
    .mobile-th {
        min-width: 40px !important;
        max-width: 60px !important;
    }
}
.editButton:hover{
    transform: scale(1.5);
    transition: transform 0.2s ease-in-out;

}
.deleteButton{
    transform: scale(1.5);
    transition: transform 0.2s ease-in-out;
}

::v-deep .custom-good-table table.vgt-table {
    border: 1px solid #dee2e6 !important;
    border-collapse: collapse !important;
    width: 100% !important;
}

::v-deep .custom-good-table table.vgt-table th {
    border: 1px solid #dee2e6 !important;
    vertical-align: middle !important;
    padding: 12px 8px !important;
    background-color: #ffffff !important;
    box-sizing: border-box !important;
}

::v-deep .custom-good-table table.vgt-table td {
    border: 1px solid #dee2e6 !important;
    vertical-align: middle !important;
    padding: 12px 10px !important;
    box-sizing: border-box !important;
}

::v-deep .custom-good-table table.vgt-table tbody tr {
    border-bottom: 1px solid #dee2e6 !important;
}

::v-deep .custom-good-table table.vgt-table tbody tr:hover td {
    background-color: #f8fafc !important;
}

::v-deep .custom-good-table table.vgt-table tbody tr.table-footer-row {
    background-color: #ffffff !important;
    border-top: 2px solid #cbd5e1 !important;
}

::v-deep .custom-good-table table.vgt-table tbody tr.table-footer-row td {
    background-color: #ffffff !important;
    padding: 10px 8px !important;
}

::v-deep .custom-good-table table.vgt-table tbody tr.table-footer-row .btn {
    padding: 6px 12px !important;
    margin-bottom: 4px !important;
    font-weight: 600 !important;
}

.table-action-btn {
    padding: 6px 10px !important;
    margin: 4px 0 !important;
    border-radius: 6px !important;
}

/* Ensure native checkbox stays hidden so double checkbox shadow is eliminated */
::v-deep .custom-good-table input[type="checkbox"].custom-control-input {
    opacity: 0 !important;
    position: absolute !important;
    z-index: -1 !important;
    width: 0 !important;
    height: 0 !important;
}

::v-deep .custom-good-table .custom-control-input:disabled ~ .custom-control-label::before {
    background-color: #e2e8f0 !important;
    border-color: #cbd5e1 !important;
    opacity: 0.85 !important;
}

::v-deep .custom-good-table .custom-control-input:disabled ~ .custom-control-label {
    color: #334155 !important;
    cursor: not-allowed !important;
}

::v-deep .custom-good-table .small-text.text-muted {
    color: #475569 !important;
}

.exam-header-title {
    background-color: #e0f2fe;
    border: 1px solid #bae6fd !important;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 6px;
}

.exam-title-text {
    font-size: 0.8rem;
    letter-spacing: 0.3px;
    white-space: normal !important;
    word-break: break-word !important;
    line-height: 1.2;
    text-align: center;
    display: block;
    width: 100%;
    color: #0369a1 !important;
}
</style>
